export const scrollToTop = (e?: Event) => {
  if (e) {
    e.preventDefault();
  }
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export const initScrollToTop = () => {
  if (typeof window === 'undefined') return;
  
  const scrollTopButton = document.getElementById('kt_scrolltop');
  if (scrollTopButton) {
    const handleClick = (e: Event) => scrollToTop(e);
    scrollTopButton.addEventListener('click', handleClick);
    
    // Show/hide button based on scroll position
    const handleScroll = () => {
      if (window.scrollY > 300) {
        scrollTopButton.style.display = 'block';
      } else {
        scrollTopButton.style.display = 'none';
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    return () => {
      scrollTopButton.removeEventListener('click', handleClick);
      window.removeEventListener('scroll', handleScroll);
    };
  }
  return undefined;
};

